import { Part } from "../reducers/models/parts";

export function partsAreTheSame(
  a_ids: (string | null)[],
  b_id: (string | null)[],
): boolean {
  const a_set = new Set(a_ids.filter((a_id) => a_id !== null));
  return b_id.some((id) => id !== null && a_set.has(id));
}

export function getIdForPart(part: Part): string {
  if (part.id !== null) {
    return part.id;
  }
  return part.octopart_id as string;
}

export const CONTAINER_ID_PREFIX = "FPCB-C-";
export const BIN_ID_PREXIX = "FPCB-B-";
